//获取列表的高度
export const getTableHeight = height => {
  let tableHeight
  if (window.innerHeight - height <= 300) {
    tableHeight = 300
  } else {
    tableHeight = window.innerHeight - height
  }
  return tableHeight
}

//获取列表的动态高度
export const getTableStateHeight = (outerDom, topDom, otherHeight = 0) => {
  const outerDomHeight = document.getElementsByClassName(outerDom)[0] ? document.getElementsByClassName(outerDom)[0].clientHeight : 0
  const searchDomHeight = document.getElementsByClassName(topDom)[0] ? document.getElementsByClassName(topDom)[0].clientHeight : 0
  let tableHeight
  if (outerDomHeight - searchDomHeight - otherHeight <= 300) {
    tableHeight = 300
  } else {
    tableHeight = outerDomHeight - searchDomHeight - otherHeight
  }
  return tableHeight
}

export const htmlDecode = html => {
  const div = document.createElement('div')
  div.innerHTML = html
  return div.innerText
}

export const  merchantAccount = [
  '13212345678',
  '13266666666',
  '13255555555',
  '13277777777'
]

